
productJS();

async function productJS() {

  //Check inventory by API
  try {

    const response = await fetch(
      `https://api.rubyshines.com/api/v1/product-inventory?productID=${encodeURIComponent(productID)}&country=${encodeURIComponent(shopifyCountryCode)}`
    );

    if (response.ok) {
      const data = await response.json();
      if (Array.isArray(data)) {
        // Update product variants with country-specific inventory
        for (const variant of productVariants) {
          const inventoryItem = data.find(item => item.variantId == variant.id);
          if (inventoryItem) {
            variant.quantity = inventoryItem.quantity;
            variant.committed = inventoryItem.committed;
            variant.incoming = inventoryItem.incoming;
            variant.incomingDate = inventoryItem.incomingDate;
          }
        }
        processNewInventory();
      }
    } else {
      console.error('Error fetching country-specific inventory:', response.status);
    }
  } catch (e) {
    console.error('Exception while fetching country-specific inventory:', e.message);
  }


  //Mock response for testing /products/the-brooke-bra
  // let data = [
  //   {
  //     "variantId": "40065713242197",
  //     "quantity": 0,
  //     "committed": 0,
  //     "incoming": 3,
  //     "incomingDate": "2025-06-30"
  //   },
  //   {
  //     "variantId": "40065713307733",
  //     "quantity": 0,
  //     "committed": 0,
  //     "incoming": 20,
  //     "incomingDate": "2025-07-31"
  //   },
  //   {
  //     "variantId": "40065713373269",
  //     "quantity": 6,
  //     "committed": 0,
  //     "incoming": 9,
  //     "incomingDate": "2025-06-30"
  //   },
  //   {
  //     "variantId": "40065713438805",
  //     "quantity": 8,
  //     "committed": 0,
  //     "incoming": 18,
  //     "incomingDate": "2025-06-30"
  //   },
  //   {
  //     "variantId": "40065713504341",
  //     "quantity": 7,
  //     "committed": 0,
  //     "incoming": 40,
  //     "incomingDate": "2025-07-31"
  //   },
  //   {
  //     "variantId": "40065713569877",
  //     "quantity": 0,
  //     "committed": 0,
  //     "incoming": 18,
  //     "incomingDate": "2025-06-30"
  //   },
  //   {
  //     "variantId": "46768001909014",
  //     "quantity": 4,
  //     "committed": 0,
  //     "incoming": 6,
  //     "incomingDate": "2025-06-30"
  //   },
  //   {
  //     "variantId": "46768001941782",
  //     "quantity": 10,
  //     "committed": 0,
  //     "incoming": 6,
  //     "incomingDate": "2025-06-30"
  //   },
  //   {
  //     "variantId": "46768001974550",
  //     "quantity": 0,
  //     "committed": 1,
  //     "incoming": 170,
  //     "incomingDate": "2025-07-31"
  //   },
  //   {
  //     "variantId": "40065713635413",
  //     "quantity": 0,
  //     "committed": 1,
  //     "incoming": 150,
  //     "incomingDate": "2025-07-31"
  //   },
  //   {
  //     "variantId": "40065713700949",
  //     "quantity": 0,
  //     "committed": 1,
  //     "incoming": 110,
  //     "incomingDate": "2025-07-31"
  //   },
  //   {
  //     "variantId": "40065713766485",
  //     "quantity": 0,
  //     "committed": 2,
  //     "incoming": 110,
  //     "incomingDate": "2025-07-31"
  //   },
  //   {
  //     "variantId": "40065713832021",
  //     "quantity": 4,
  //     "committed": 0,
  //     "incoming": 60,
  //     "incomingDate": "2025-07-31"
  //   },
  //   {
  //     "variantId": "46475431772438",
  //     "quantity": 4,
  //     "committed": 0,
  //     "incoming": 40,
  //     "incomingDate": "2025-07-31"
  //   },
  //   {
  //     "variantId": "40065713274965",
  //     "quantity": 0,
  //     "committed": 0,
  //     "incoming": 0
  //   },
  //   {
  //     "variantId": "40065713340501",
  //     "quantity": 5,
  //     "committed": 0,
  //     "incoming": 9,
  //     "incomingDate": "2025-06-30"
  //   },
  //   {
  //     "variantId": "40065713406037",
  //     "quantity": 0,
  //     "committed": 0,
  //     "incoming": 6,
  //     "incomingDate": "2025-06-30"
  //   },
  //   {
  //     "variantId": "40065713471573",
  //     "quantity": 7,
  //     "committed": 0,
  //     "incoming": 4,
  //     "incomingDate": "2025-06-30"
  //   },
  //   {
  //     "variantId": "40065713537109",
  //     "quantity": 7,
  //     "committed": 1,
  //     "incoming": 21,
  //     "incomingDate": "2025-06-30"
  //   },
  //   {
  //     "variantId": "40065713602645",
  //     "quantity": 0,
  //     "committed": 0,
  //     "incoming": 21,
  //     "incomingDate": "2025-06-30"
  //   },
  //   {
  //     "variantId": "46768002007318",
  //     "quantity": 3,
  //     "committed": 0,
  //     "incoming": 18,
  //     "incomingDate": "2025-06-30"
  //   },
  //   {
  //     "variantId": "46768002072854",
  //     "quantity": 9,
  //     "committed": 0,
  //     "incoming": 60,
  //     "incomingDate": "2025-07-31"
  //   },
  //   {
  //     "variantId": "46768002138390",
  //     "quantity": 10,
  //     "committed": 0,
  //     "incoming": 30,
  //     "incomingDate": "2025-06-30"
  //   },
  //   {
  //     "variantId": "40065713668181",
  //     "quantity": 0,
  //     "committed": 0,
  //     "incoming": 60,
  //     "incomingDate": "2025-07-31"
  //   },
  //   {
  //     "variantId": "40065713733717",
  //     "quantity": 6,
  //     "committed": 0,
  //     "incoming": 4,
  //     "incomingDate": "2025-06-30"
  //   },
  //   {
  //     "variantId": "40065713799253",
  //     "quantity": 8,
  //     "committed": 0,
  //     "incoming": 6,
  //     "incomingDate": "2025-06-30"
  //   },
  //   {
  //     "variantId": "40065713864789",
  //     "quantity": 5,
  //     "committed": 0,
  //     "incoming": 9,
  //     "incomingDate": "2025-06-30"
  //   },
  //   {
  //     "variantId": "46475431805206",
  //     "quantity": 4,
  //     "committed": 0,
  //     "incoming": 15,
  //     "incomingDate": "2025-06-30"
  //   },
  //   {
  //     "variantId": "45016776900886",
  //     "quantity": 5,
  //     "committed": 0,
  //     "incoming": 0
  //   },
  //   {
  //     "variantId": "45016776933654",
  //     "quantity": 0,
  //     "committed": 0,
  //     "incoming": 20,
  //     "incomingDate": "2025-07-31"
  //   },
  //   {
  //     "variantId": "45016776966422",
  //     "quantity": 4,
  //     "committed": 0,
  //     "incoming": 0
  //   },
  //   {
  //     "variantId": "45016776999190",
  //     "quantity": 4,
  //     "committed": 0,
  //     "incoming": 0
  //   },
  //   {
  //     "variantId": "45016777031958",
  //     "quantity": 5,
  //     "committed": 0,
  //     "incoming": 6,
  //     "incomingDate": "2025-06-30"
  //   },
  //   {
  //     "variantId": "45016777064726",
  //     "quantity": 5,
  //     "committed": 0,
  //     "incoming": 20,
  //     "incomingDate": "2025-07-31"
  //   },
  //   {
  //     "variantId": "46768002236694",
  //     "quantity": 4,
  //     "committed": 0,
  //     "incoming": 0
  //   },
  //   {
  //     "variantId": "46768002269462",
  //     "quantity": 4,
  //     "committed": 0,
  //     "incoming": 20,
  //     "incomingDate": "2025-07-31"
  //   },
  //   {
  //     "variantId": "46768002302230",
  //     "quantity": 7,
  //     "committed": 0,
  //     "incoming": 9,
  //     "incomingDate": "2025-06-30"
  //   },
  //   {
  //     "variantId": "45016777097494",
  //     "quantity": 0,
  //     "committed": 0,
  //     "incoming": 40,
  //     "incomingDate": "2025-07-31"
  //   },
  //   {
  //     "variantId": "45016777130262",
  //     "quantity": 3,
  //     "committed": 0,
  //     "incoming": 9,
  //     "incomingDate": "2025-06-30"
  //   },
  //   {
  //     "variantId": "45016777163030",
  //     "quantity": 3,
  //     "committed": 0,
  //     "incoming": 9,
  //     "incomingDate": "2025-06-30"
  //   },
  //   {
  //     "variantId": "45016777195798",
  //     "quantity": 5,
  //     "committed": 0,
  //     "incoming": 9,
  //     "incomingDate": "2025-06-30"
  //   },
  //   {
  //     "variantId": "46475431837974",
  //     "quantity": 4,
  //     "committed": 0,
  //     "incoming": 9,
  //     "incomingDate": "2025-06-30"
  //   }
  // ];
  // for (const variant of productVariants) {
  //   const inventoryItem = data.find(item => item.variantId == variant.id);
  //   if (inventoryItem) {
  //     variant.quantity = inventoryItem.quantity;
  //     variant.committed = inventoryItem.committed;
  //     variant.incoming = inventoryItem.incoming;
  //     variant.incomingDate = inventoryItem.incomingDate;
  //   }
  // }
  // processNewInventory();

  //handle bundle options
  if ($(".bundleOptionsProduct").length > 0) {
    // Disable size select boxes until data is loaded and add blank option
    $('.bundleOptionsProductVariants variant-selects select').each(function () {
      $(this).attr('disabled', true);
      // Add blank option at the beginning if it doesn't exist
      if ($(this).find('option[value=""]').length === 0) {
        $(this).prepend('<option value="" selected>Select size</option>');
      } else {
        $(this).val('');
      }
    });

    // Disable add to cart button initially
    $(".product-form").find(".product-form__submit").attr("disabled", true);

    // Fetch inventory for bundle products
    async function fetchBundleInventory() {
      // Group variants by productId to minimize API calls
      const productIds = [...new Set(bundleProducts.map(item => item.productId))];

      for (const productId of productIds) {
        try {
          const response = await fetch(
            `https://api.rubyshines.com/api/v1/product-inventory?productID=${encodeURIComponent(productId)}&country=${encodeURIComponent(shopifyCountryCode)}`
          );
          if (response.ok) {
            const data = await response.json();
            if (Array.isArray(data)) {
              // Update bundle items with matching variant IDs
              for (const bundleItem of bundleProducts) {
                if (bundleItem.productId == productId) {
                  const inventoryItem = data.find(item => item.variantId == bundleItem.id);
                  if (inventoryItem) {
                    bundleItem.incomingDate = inventoryItem.incomingDate;
                    bundleItem.quantity = inventoryItem.quantity;
                    bundleItem.incoming = inventoryItem.incoming;
                    bundleItem.committed = inventoryItem.committed;
                  }
                }
              }
            }
          }
        } catch (e) {
          console.error('Error fetching bundle inventory:', e);
        }
      }
    }

    fetchBundleInventory().then(() => {
      // Process bundle products to add equivalent sizes
      processBundleInventory();

      waitForElm1("#simple-bundles-io-options").then((elm) => {
        // Add change listeners first
        $(".bundleOptionsProductVariants variant-selects select").on("change", function () {
          if ($(this).val() !== "") {
            // Remove the blank "Select size" option after a size is selected
            $(this).find('option[value=""]').remove();
          }
        });

        // Add listener for color selection to handle size reset
        $(".bundleOptionsProduct").each(function () {
          let currentBundleProduct = $(this);
          let colorInputs = currentBundleProduct.find("variant-selects>*:not(script)").eq(0).find("input");

          if (colorInputs.length > 0) {
            colorInputs.on("change", function () {
              handleColorSelectionChange(currentBundleProduct, $(this));
            });
          }
        });

        $(".bundleOptionsProduct input, .bundleOptionsProduct select").on(
          "change",
          function () {
            updateBundleValue(this);
          }
        );

        // Trigger initial check for each bundle product to set correct disabled state BEFORE enabling
        $(".bundleOptionsProduct").each(function () {
          let firstInput = $(this).find("input:checked, select").first();
          if (firstInput.length > 0) {
            updateBundleValue(firstInput[0]);
          }
        });

        // Re-enable size select boxes after setting correct state
        setTimeout(function () {
          $('.bundleOptionsProductVariants variant-selects select').removeAttr('disabled');
          $(".bundleOptionsWrapper").show();
        }, 100);
      });
    });
  }

  setTimeout(function () {
    checkStickyBar();
  }
    , 300);
  //sticky bar
  $(window).on("load", function () {
    checkStickyBar();
  });
  $(".product__accordion").on("click", function () {
    setTimeout(function () {
      checkStickyBar();
    }
      , 100);
  });

  //Review star click
  $(".product .rating-wrapper").on("click", function () {
    if ($(window).width() > 989) {
      $("html, body").animate(
        { scrollTop: $(".product-reviews-wrapper").offset().top - 150 },
        1000
      );
    } else {
      $("html, body").animate(
        { scrollTop: $(".product-reviews-wrapper").offset().top - 30 },
        1000
      );
    }
  });

  //Write a review click
  waitForElm1(".jdgm-widget-actions-wrapper .jdgm-write-rev-link").then((elm) => {
    $(elm).on("click", function () {
      if ($(this).attr("aria-expanded") == "false") {
        setTimeout(function () {
          if ($(window).width() > 989) {
            $("html, body").animate(
              { scrollTop: $(".product-reviews-wrapper").offset().top - 150 },
              1000
            );
          } else {
            $("html, body").animate(
              { scrollTop: $(".product-reviews-wrapper").offset().top - 30 },
              1000
            );
          }
        }, 500);
      }
    });
  });

  //Round Judge.me review score to one decimal
  function roundJudgeMeScore() {
    const scoreElement = document.querySelector('.jdgm-rev-widg__summary-average .jdgm-link');
    if (scoreElement) {
      const text = scoreElement.textContent;
      const scoreMatch = text.match(/(\d+\.\d+)\s+out of/);
      if (scoreMatch) {
        const originalScore = parseFloat(scoreMatch[1]);
        const roundedScore = originalScore.toFixed(1);
        scoreElement.textContent = text.replace(scoreMatch[1], roundedScore);
      }
    }
  }

  // Watch for Judge.me widget to load
  waitForElm1('.jdgm-rev-widg__summary-average .jdgm-link').then(() => {
    roundJudgeMeScore();
  });

  //Kid/adult toggle
  if ($(".product__info-container .swatch-input__input").length > 0) {
    var selectedColor = $(".product__info-container .swatch-input__input:checked").val();
    $("body").addClass(selectedColor.replace(" ", ""));
  }
  if (hasKidAdultToggle) {
    var currentSizeType = getCookie("currentSizeType");


    //Adult/Kid toggle
    $(".variantTypeSelect").on("click", function () {
      let thisType = $(this).data("type");
      setCookie("currentSizeType", thisType, 365);
      $(".variantTypeSelect").removeClass("active");
      $(this).addClass("active");
      if (thisType == "adults") {
        $("body").addClass("adults");
        $("body").removeClass("childs");
        // document.querySelector(".sizeLabel").textContent = adultsSizeLabel;
        if ($(".pdPriceVaries.active").length > 0) {
          $(".pdPriceVariesKids, .pdPriceNoVaries").removeClass("active");
          $(".pdPriceVariesAdults").addClass("active");
        }
      } else {
        $("body").addClass("childs");
        $("body").removeClass("adults");
        // document.querySelector(".sizeLabel").textContent = kidsSizeLabel;
        if ($(".pdPriceVaries.active").length > 0) {
          $(".pdPriceVariesAdults, .pdPriceNoVaries").removeClass("active");
          $(".pdPriceVariesKids").addClass("active");
        }
      }
    });
  } else {
    // For products without toggle, set appropriate body class based on available sizes
    // Check if product has only adult sizes or only kid sizes
    var hasAdultSizes = $(".sizeSwatchType[is-adults]").length > 0;
    var hasKidSizes = $(".sizeSwatchType[is-kids]").length > 0;

    if (hasAdultSizes && !hasKidSizes) {
      // Product has only adult sizes - set adults class
      $("body").addClass("adults");
      $("body").removeClass("childs");
    } else if (hasKidSizes && !hasAdultSizes) {
      // Product has only kid sizes - set childs class
      $("body").addClass("childs");
      $("body").removeClass("adults");
    }
  }

  //Size guide popup
  $(".sizeGuideTab").on("click", function (e) {
    e.stopPropagation();
    e.preventDefault();
    let thisParent = $(this).closest(".sizeGuidewrapper");
    thisParent.find(".sizeGuideTab").removeClass("active");
    thisParent.find(".sizeGuideContent").removeClass("active");
    $(this).addClass("active");
    let tabId = $(this).attr("data-index");
    thisParent.find(".sizeGuideContent[data-index='" + tabId + "']")
      .addClass("active");
  });
}


function processBundleInventory() {
  // Parse size and color from variant_title for bundle products
  for (const bundleItem of bundleProducts) {
    if (bundleItem.variant_title) {
      const parts = bundleItem.variant_title.split(' - ');
      if (parts.length > 1) {
        const variantOptions = parts[1].split(' / ');
        // Assuming first part is color, second is size (adjust if needed)
        if (variantOptions.length >= 2) {
          bundleItem.color = variantOptions[0];
          bundleItem.size = variantOptions[1];
        } else if (variantOptions.length === 1) {
          bundleItem.size = variantOptions[0];
        }
      }
    }
  }

  const kidsSizes = ['12', '13', '14', '16', '14 Tall', '16 Tall'];
  const adultSizes = ['XS', 'XS+', 'S', 'M', 'S Tall', 'M Tall'];

  // Group bundle items by product
  const bundlesByProduct = {};
  for (const bundleItem of bundleProducts) {
    if (!bundlesByProduct[bundleItem.productId]) {
      bundlesByProduct[bundleItem.productId] = [];
    }
    bundlesByProduct[bundleItem.productId].push(bundleItem);
  }

  // Process equivalent sizes for each bundle item
  for (const bundleItem of bundleProducts) {
    if (bundleItem.quantity <= 0 && bundleItem.size) {
      let equivSize;
      let isAdultSize = adultSizes.includes(bundleItem.size);
      let isKidSize = kidsSizes.includes(bundleItem.size);

      if (isAdultSize) {
        equivSize = kidsSizes[adultSizes.indexOf(bundleItem.size)];
      } else if (isKidSize) {
        equivSize = adultSizes[kidsSizes.indexOf(bundleItem.size)];
      }

      if (equivSize) {
        // Look for equivalent variant in the same product
        const sameProdBundles = bundlesByProduct[bundleItem.productId] || [];
        for (const equivalentItem of sameProdBundles) {
          if (equivalentItem.quantity > 0 && equivalentItem.size === equivSize) {
            // Check color match if both have colors
            if (!bundleItem.color || !equivalentItem.color || equivalentItem.color === bundleItem.color) {
              bundleItem.equivalentSize = equivalentItem.size;
              break;
            }
          }
        }
      }
    }
  }
}

function processNewInventory() {
  //add equivalent size to product variants list
  for (const productVariant of productVariants) {
    for (const key of Object.keys(productVariant.options)) {
      if (key.toLowerCase().indexOf("color") != - 1) {
        productHasColorSetting = true;
        productVariant.color = productVariant.options[key]
      }
      if (key.toLowerCase().indexOf("size") != - 1) {
        productHasSizeSetting = true;
        productVariant.size = productVariant.options[key]
      }
    }
    if (ageRangeVariants && ageRangeVariants["adults"] && ageRangeVariants["adults"].allowedValues) {
      productVariant.isAdults = (ageRangeVariants["adults"].allowedValues.includes(productVariant.size))
    }
    productVariant.options = undefined;
  }
  const kidsSizes = ['12', '13', '14', '16', '14 Tall', '16 Tall'];
  const adultSizes = ['XS', 'XS+', 'S', 'M', 'S Tall', 'M Tall'];
  for (const productVariant of productVariants) {
    if (productVariant.quantity <= 0) {

      let equivSize;
      if (productVariant.isAdults && adultSizes.includes(productVariant.size)) {
        equivSize = kidsSizes[adultSizes.indexOf(productVariant.size)];
      }
      else if (!productVariant.isAdults && kidsSizes.includes(productVariant.size)) {
        // console.log("index", productVariant.size, kidsSizes, kidsSizes.indexOf(productVariant.size))
        equivSize = adultSizes[kidsSizes.indexOf(productVariant.size)];
      }

      if (equivSize) {
        for (const equivalentVariant of productVariants) {
          if (equivalentVariant.quantity > 0 && equivalentVariant.size == equivSize && (!productHasColorSetting || (equivalentVariant.color == productVariant.color))) {
            productVariant.equivalentSize = equivalentVariant.size
          }
        }
      }

    }
  }

  //updateUI
  //Call updateUI on first load to check size availability including equivalent sizes
  let productForm = document.querySelector('.product__info-container product-form form');
  if (!$(productForm).find(".product-form__submit").hasClass("noVariantSelectedYet")) {
    updateUI();
  } else {
    // Also call updateUI on first load to properly show size availability
    updateSizeAvailability();
  }
}
function updateSizeAvailability() {
  //Update size available (same logic as in updateUI, but runs on first page load)
  if ($("variant-selects fieldset.product-form__input--pill").length > 0) {
    $("variant-selects fieldset.product-form__input--pill input[type='radio']").each(function (index) {
      let that = this;
      //If have color select
      let isAvailable = false;
      let thisOptionIds = [
        $(that).attr("data-option-value-id"),
      ];
      if ($("variant-selects fieldset.product-form__input--swatch").length > 0) {
        let selectedColorElem = $("variant-selects fieldset.product-form__input--swatch input[type='radio']:checked");
        thisOptionIds.push(selectedColorElem.attr("data-option-value-id"));
        for (variant of productVariants) {
          if (variant.quantity > 0 || variant.continue_selling == "true" || variant.equivalentSize) {
            if (variant.option_ids && arraysEqual(variant.option_ids, thisOptionIds)) {
              isAvailable = true;
              break;
            }
          }
        }
      } else {
        for (variant of productVariants) {
          if (variant.quantity > 0 || variant.continue_selling == "true" || variant.equivalentSize) {
            if (variant.option_ids && arraysEqual(variant.option_ids, thisOptionIds)) {
              isAvailable = true;
              break;
            }
          }
        }
      }
      if (isAvailable) {
        $(that).removeAttr("disabled");
        $(that).removeClass("disabled");
      } else {
        $(that).attr("disabled", "disabled");
        $(that).addClass("disabled");
      }
    });
  }
}

function checkStickyBar() {
  if ($(".product__column-sticky1").height() > $(window).height()) {
    $(".product__column-sticky1").css("top", "-" + ($(".product__column-sticky1").height() - $(window).height() + 10) + "px");
  } else {
    $(".product__column-sticky1").css("top", "0px");
  }
}

function updateUI() {
  //Update size available
  if ($("variant-selects fieldset.product-form__input--pill").length > 0) {
    $("variant-selects fieldset.product-form__input--pill input[type='radio']").each(function (index) {
      let that = this;
      //If have color select
      let isAvailable = false;
      let thisOptionIds = [
        $(that).attr("data-option-value-id"),
      ];
      if ($("variant-selects fieldset.product-form__input--swatch").length > 0) {
        let selectedColorElem = $("variant-selects fieldset.product-form__input--swatch input[type='radio']:checked");
        thisOptionIds.push(selectedColorElem.attr("data-option-value-id"));
        for (variant of productVariants) {
          if (variant.quantity > 0 || variant.continue_selling == "true" || variant.equivalentSize) {
            if (variant.option_ids && arraysEqual(variant.option_ids, thisOptionIds)) {
              isAvailable = true;
              break;
            }
          }
        }
      } else {
        for (variant of productVariants) {
          if (variant.quantity > 0 || variant.continue_selling == "true" || variant.equivalentSize) {
            if (variant.option_ids && arraysEqual(variant.option_ids, thisOptionIds)) {
              isAvailable = true;
              break;
            }
          }
        }
      }
      if (isAvailable) {
        $(that).removeAttr("disabled");
        $(that).removeClass("disabled");
      } else {
        $(that).attr("disabled", "disabled");
        $(that).addClass("disabled");
      }
    });
  }

  //Update product form status
  let selectedVariantInput = document.querySelector(`.product__info-container product-form form [name="id"]`);
  let selectedVariant = selectedVariantInput.value;
  let currentVariant = productVariants.find((variant) => variant.id === selectedVariant);
  let productForm = document.querySelector('.product__info-container product-form form');
  let soldOut = true;
  if ((currentVariant.quantity > 0 || currentVariant.continue_selling == "true" || currentVariant.equivalentSize)) {
    soldOut = false;

  }
  if (soldOut) { //Variant sold out
    $(productForm).find(".product-form__submit").attr('disabled', 'disabled');
    if ($(productForm).find(".product-form__submit span")) {
      $(productForm).find(".product-form__submit span").text("Sold Out");
    } else {
      $(productForm).find(".product-form__submit").text("Sold Out");
    }
    $("#preorder-item-info").remove();
    $(".preOrderOnPdp").html('');
    $("#size-swap-info")?.remove();
  } else { //Variant avaialble
    $(productForm).find(".product-form__submit").removeAttr("disabled");
    if (currentVariant.available && currentVariant.quantity <= 0 && !currentVariant.equivalentSize) { //Variant avaialble without equivalent size
      function describeDate(dateString) {
        const date = new Date(dateString + 'T00:00:00Z');
        const year = date.getUTCFullYear();
        const month = date.getUTCMonth();
        const day = date.getUTCDate();
        const monthAbbreviations = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        if (day <= 10) {
          return `beginning of ${monthAbbreviations[month]}, ${year}`;
        }
        else if (day >= 21) {
          return `end of ${monthAbbreviations[month]}, ${year}`;
        }
        else {
          return `middle of ${monthAbbreviations[month]}, ${year}`;
        }
      }
      let preorderDescription = '<div>This is a pre-order item.  </div>';

      if (currentVariant && currentVariant.incomingDate) {
        const availabilityString = describeDate(currentVariant.incomingDate);
        preorderDescription += `<div>Target availability ${availabilityString}. <modal-opener class="product-popup-modal__opener quick-add-hidden" data-modal="#preorderInfoPopup">
                      <button id="ProductPopup-size_popup_pMBFUi" class="product-popup-modal__button link" type="button" aria-haspopup="dialog">
                        Learn more.
                      </button>
                    </modal-opener></div>`;
        $(".preOrderOnPdp").html(preorderDescription);
        const hiddenFieldHTML = `<input type="hidden" id="preorder-item-info" value="Target availability ${availabilityString}." name="properties[Pre-order]">`;
        $(productForm).append(hiddenFieldHTML);
      }
      $(".deliveryLearnMore").off("click");
      $(".deliveryLearnMore").on("click", function (e) {
        e.preventDefault();
      });
      // $("#preorder-item-info-container").html(hiddenFieldHTML);
      if ($(productForm).find(".product-form__submit span")) {
        $(productForm).find(".product-form__submit span").text("Pre-order Now");
      } else {
        $(productForm).find(".product-form__submit").text("Pre-order Now");
      }
      $("#size-swap-info")?.remove();
    }
    else if (currentVariant.quantity <= 0 && currentVariant.equivalentSize) { //Variant avaialble with equivalent size
      const toYouth = ['12', '13', '14', '16'].includes(currentVariant.equivalentSize);
      const message = `<div>This size is out of stock.</div><div>We will add the same ${toYouth ? 'youth size' : 'adult size'} ${currentVariant.equivalentSize} to your cart.</div>`
      let productForm = document.querySelector('.product__info-container product-form form');
      let submitButton = document.querySelector('.product-form__buttons .product-form__submit');
      let submitButtonText = submitButton.querySelector('span');
      submitButton.removeAttribute('disabled');
      submitButtonText.textContent = window.variantStrings.addToCart;
      $('.preOrderOnPdp').html(message);
      const swapMessage = `${toYouth ? 'Youth size' : 'Adult size'} ${currentVariant.equivalentSize} is the same as ${toYouth ? 'adult size' : 'youth size'} ${currentVariant.size}.`;
      const hiddenFieldHTML = `<input type="hidden" id="size-swap-info" value="${swapMessage}" name="properties[Size Swap]">`;
      $(productForm).append(hiddenFieldHTML);
      //get equivalent variant
      let equivalentVariant = currentVariant;
      if (currentVariant.color) {
        equivalentVariant = productVariants.find((variant) => variant.size === currentVariant.equivalentSize && variant?.color === currentVariant?.color);
      } else {
        equivalentVariant = productVariants.find((variant) => variant.size === currentVariant.equivalentSize);
      }
      selectedVariantInput.value = equivalentVariant.id;
      return true;
    }
    else if (currentVariant.available && (currentVariant.quantity > 0 && currentVariant.quantity < 5)) { //Variant avaialble with less than 5 quantity
      $(".preOrderOnPdp").html(`<div>Only ${currentVariant.quantity} left in stock!</div>`);
      if ($(productForm).find(".product-form__submit span")) {
        $(productForm).find(".product-form__submit span").text("Add To Cart");
      } else {
        $(productForm).find(".product-form__submit").text("Add To Cart");
      }
      $("#size-swap-info")?.remove();
    }
    else { //Other cases
      $("#preorder-item-info").remove();
      $(".preOrderOnPdp").html('');
      if ($(productForm).find(".product-form__submit span")) {
        $(productForm).find(".product-form__submit span").text("Add To Cart");
      } else {
        $(productForm).find(".product-form__submit").text("Add To Cart");
      }
      $("#size-swap-info")?.remove();
    }
  }
}

//function to check 2 array of string equal, regardless of order
function arraysEqual(a, b) {
  if (a.length !== b.length) return false;
  const sortedA = a.slice().sort();
  const sortedB = b.slice().sort();
  for (let i = 0; i < sortedA.length; i++) {
    if (sortedA[i] !== sortedB[i]) return false;
  }
  return true;
}
function removeColorClassFromBody(colorArray) {
  //Remove all color class from body
  colorArray.forEach(function (item) {
    $("body").removeClass(item.replace(" ", ""));
  });
}

function describeDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString + 'T00:00:00Z');
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth();
  const day = date.getUTCDate();
  const monthAbbreviations = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  if (day <= 10) {
    return `beginning of ${monthAbbreviations[month]}, ${year}`;
  }
  else if (day >= 21) {
    return `end of ${monthAbbreviations[month]}, ${year}`;
  }
  else {
    return `middle of ${monthAbbreviations[month]}, ${year}`;
  }
}

function handleColorSelectionChange(currentBundleProduct, selectedColorInput) {
  // Get selected color value
  let selectedColor = selectedColorInput.val();

  // Get size select box
  let sizeSelect = currentBundleProduct.find("variant-selects>*:not(script)").eq(1).find("select");

  if (sizeSelect.length > 0) {
    let currentSize = sizeSelect.val();

    // If no size selected yet, do nothing
    if (!currentSize || currentSize === "") {
      return;
    }

    // Get product title
    let productTitle = currentBundleProduct.find(".bundleOptionsProductTitle").text();
    let selectedVariant = productTitle + " - " + selectedColor + " / " + currentSize;

    // Check if this variant is truly sold out (no quantity, no incoming, no equivalent size)
    let isTrulySoldOut = false;
    for (const bundleItem of bundleProducts) {
      if (bundleItem.variant_title === selectedVariant) {
        // Truly sold out if no quantity AND no incoming AND no equivalent size
        if (bundleItem.quantity <= 0 &&
          (bundleItem.incoming <= 0 || !bundleItem.incoming) &&
          !bundleItem.equivalentSize) {
          isTrulySoldOut = true;
        }
        break;
      }
    }

    // If truly sold out, reset size dropdown to "Select size"
    if (isTrulySoldOut) {
      // Add the blank option back if it doesn't exist
      if (sizeSelect.find('option[value=""]').length === 0) {
        sizeSelect.prepend('<option value="" selected>Select size</option>');
      }
      sizeSelect.val('');
    }
  }
}

function updateBundleValue(elem) {
  //Update all dropdown value by the select box change
  if ($("variant-selects>*:not(script)").length > 1) {
    let currentBundleProduct = $(elem).closest(".bundleOptionsProduct");
    let currentIndex =
      Number($(elem).closest("[data-index]").attr("data-index")) - 1;
    let otherSelect = $(
      currentBundleProduct.find("variant-selects>*:not(script)")[0]
    );
    let thisVal1 = "";
    if (currentIndex == 1) {
      otherSelect = $(
        currentBundleProduct.find("variant-selects>*:not(script)")[1]
      );
    }
    if (otherSelect.find("input").length > 0) {
      thisVal1 = otherSelect.find("input:checked").val();
    } else if (otherSelect.find("select").length > 0) {
      thisVal1 = otherSelect.find("select").val();
    }
    let productTitle = currentBundleProduct
      .find(".bundleOptionsProductTitle")
      .text();
    // Find app select box by checking which select has options matching this product title
    let appSelectBox = null;
    $("#simple-bundles-io-options select").each(function () {
      let firstAppOption = $(this).find("option:not([value=''])").first();
      if (firstAppOption.length > 0) {
        let appOptionValue = firstAppOption.val();
        if (appOptionValue.startsWith(productTitle + " - ")) {
          appSelectBox = $(this);
          return false; // break the loop
        }
      }
    });
    if (!appSelectBox) {
      appSelectBox = $(); // empty jQuery object
    }
    currentBundleProduct
      .find("variant-selects>*:not(script)")
      .each(function (index1) {
        if (index1 != currentIndex) {
          // Check if this is a color option (index 0) or size option (index 1)
          let isColorOption = (index1 == 0);

          if ($(this).find("input").length > 0) {
            $(this)
              .find("input")
              .each(function () {
                let selectedVariant = productTitle + " - ";
                let thisVal = $(this).attr("value");
                if (index1 == 0) {
                  selectedVariant =
                    selectedVariant + thisVal + " / " + thisVal1;
                } else {
                  selectedVariant =
                    selectedVariant + thisVal1 + " / " + thisVal;
                }
                let selectedAppOption = appSelectBox.find(
                  "option[value='" + selectedVariant + "']"
                );

                // Check if this variant is actually available
                let isAvailable = false;
                for (const bundleItem of bundleProducts) {
                  if (bundleItem.variant_title === selectedVariant) {
                    // Available if: has quantity OR (no quantity but has incoming stock) OR has equivalent size
                    if (bundleItem.quantity > 0 ||
                      (bundleItem.quantity <= 0 && bundleItem.incoming > 0) ||
                      bundleItem.equivalentSize) {
                      isAvailable = true;
                    }
                    break;
                  }
                }

                let isDisabled = selectedAppOption.length == 0 ||
                  (typeof selectedAppOption.attr("disabled") !== "undefined" &&
                    selectedAppOption.attr("disabled") !== false);

                // For color options, keep them always enabled but store availability
                if (isColorOption) {
                  $(this).removeAttr("disabled");
                  $(this).attr("data-available", isAvailable ? "true" : "false");
                } else {
                  // For size options, disable if not available
                  if ((isDisabled && !isAvailable) || !isAvailable) {
                    $(this).attr("disabled", true);
                  } else {
                    $(this).removeAttr("disabled");
                  }
                }
              });
          } else if ($(this).find("select").length > 0) {
            $(this)
              .find("option")
              .each(function () {
                let selectedVariant = productTitle + " - ";
                let thisVal = $(this).attr("value");
                if (index1 == 0) {
                  selectedVariant =
                    selectedVariant + thisVal + " / " + thisVal1;
                } else {
                  selectedVariant =
                    selectedVariant + thisVal1 + " / " + thisVal;
                }
                let selectedAppOption = appSelectBox.find(
                  "option[value='" + selectedVariant + "']"
                );

                // Check if this variant is actually available
                let isAvailable = false;
                for (const bundleItem of bundleProducts) {
                  if (bundleItem.variant_title === selectedVariant) {
                    // Available if: has quantity OR (no quantity but has incoming stock) OR has equivalent size
                    if (bundleItem.quantity > 0 ||
                      (bundleItem.quantity <= 0 && bundleItem.incoming > 0) ||
                      bundleItem.equivalentSize) {
                      isAvailable = true;
                    }
                    break;
                  }
                }

                let isDisabled = selectedAppOption.length == 0 ||
                  (typeof selectedAppOption.attr("disabled") !== "undefined" &&
                    selectedAppOption.attr("disabled") !== false);

                // For color options, keep them always enabled but store availability
                if (isColorOption) {
                  $(this).removeAttr("disabled");
                  $(this).attr("data-available", isAvailable ? "true" : "false");
                } else {
                  // For size options, disable if not available
                  if ((isDisabled && !isAvailable) || !isAvailable) {
                    $(this).attr("disabled", true);
                  } else {
                    $(this).removeAttr("disabled");
                  }
                }
              });
          }
        }
      });
  }
  let sold_out = false;
  let pre_order = false;
  let target_avai = "";
  let hasEquivalentSizeSwap = false;
  let equivalentSizeMessage = "";
  let hasBlankSelection = false;
  let preOrderItems = [];

  $(".bundleOptionsProduct").each(function () {
    let productTitle = $(this).find(".bundleOptionsProductTitle").text();
    // Find app select box by checking which select has options matching this product title
    let appSelectBox = null;
    $("#simple-bundles-io-options select").each(function () {
      let firstAppOption = $(this).find("option:not([value=''])").first();
      if (firstAppOption.length > 0) {
        let appOptionValue = firstAppOption.val();
        if (appOptionValue.startsWith(productTitle + " - ")) {
          appSelectBox = $(this);
          return false; // break the loop
        }
      }
    });
    if (!appSelectBox) {
      appSelectBox = $(); // empty jQuery object
    }
    let selectedVariant = productTitle + " - ";
    $(this)
      .find("variant-selects>*:not(script)")
      .each(function (index) {
        let thisVal = "";
        if ($(this).find("input").length > 0) {
          thisVal = $(this).find("input:checked").val();
        } else if ($(this).find("select").length > 0) {
          thisVal = $(this).find("select").val();
        }
        // Check if any select has blank/empty value
        if (!thisVal || thisVal === "") {
          hasBlankSelection = true;
        }
        if (index == 0) {
          selectedVariant = selectedVariant + thisVal;
        } else {
          selectedVariant = selectedVariant + " / " + thisVal;
        }
      });
    let selectedAppOption = appSelectBox.find(
      "option[value='" + selectedVariant + "']"
    );

    // Check if this variant has equivalent size available
    let hasEquivalentSize = false;
    for (const bundleItem of bundleProducts) {
      if (bundleItem.variant_title === selectedVariant && bundleItem.equivalentSize) {
        hasEquivalentSize = true;
        break;
      }
    }

    let isOptionDisabled = selectedAppOption.length == 0 ||
      (typeof selectedAppOption.attr("disabled") !== "undefined" &&
        selectedAppOption.attr("disabled") !== false);

    if (isOptionDisabled && !hasEquivalentSize) {
      sold_out = true;
    } else {
      appSelectBox.val(selectedVariant);
      let event = new Event("change");
      appSelectBox[0].dispatchEvent(event);
      $(".product-form").find("product-form__submit").removeAttr("disabled");

      bundleProducts.forEach(function (item) {
        if (item.variant_title == selectedVariant) {
          // remove debug logs

          if (item.quantity <= 0 && !item.equivalentSize) {
            // Check if there's actually incoming stock before setting pre_order
            if (item.incoming > 0 && item.incomingDate) {
              pre_order = true;
              target_avai = describeDate(item.incomingDate);
              // Store pre-order item details
              const variantOptions = item.variant_title.split(' - ')[1];
              preOrderItems.push({
                fullTitle: item.variant_title,
                variantOptions: variantOptions,
                targetAvailability: describeDate(item.incomingDate)
              });
            } else {
              // No incoming stock, should be sold out
              sold_out = true;
            }
          } else if (item.quantity <= 0 && item.equivalentSize) {
            hasEquivalentSizeSwap = true;
            const toYouth = ['12', '13', '14', '16', '14 Tall', '16 Tall'].includes(item.equivalentSize);
            const productTitleForMessage = item.variant_title.split(' - ')[0];
            const variantOptions = item.variant_title.split(' - ')[1];
            equivalentSizeMessage = `<div>${productTitleForMessage} - ${variantOptions} is out of stock.</div><div>We will add the same ${toYouth ? 'youth size' : 'adult size'} ${item.equivalentSize} to your cart.</div>`;

            // Find the equivalent variant and update the bundle app's select box
            const productTitleMatch = item.variant_title.split(' - ')[0];
            let equivalentVariantTitle = null;
            for (const equivalentItem of bundleProducts) {
              if (equivalentItem.variant_title &&
                equivalentItem.variant_title.startsWith(productTitleMatch) &&
                equivalentItem.size === item.equivalentSize &&
                equivalentItem.quantity > 0) {
                // Check if color matches (if applicable)
                if (!item.color || !equivalentItem.color || equivalentItem.color === item.color) {
                  equivalentVariantTitle = equivalentItem.variant_title;
                  break;
                }
              }
            }

            if (equivalentVariantTitle) {
              // Update the app's select box to use the equivalent variant
              appSelectBox.val(equivalentVariantTitle);
              let event = new Event("change");
              appSelectBox[0].dispatchEvent(event);
            }
          }
        }
      });
    }
  });

  // Remove any existing bundle pre-order hidden field and size swap field
  $("#bundle-preorder-item-info").remove();
  $("#bundle-size-swap-info").remove();

  if (hasBlankSelection) {
    // If any bundle product has no size selected, keep button disabled but don't change text
    $(".product-form").find(".product-form__submit").attr("disabled", true);
    $(".preOrderOnPdp").hide();
  } else if (sold_out) {
    $(".product-form").find(".product-form__submit").text("Sold out");
    $(".product-form").find(".product-form__submit").attr("disabled", true);
    $(".preOrderOnPdp").hide();
  } else {
    $(".product-form").find(".product-form__submit").removeAttr("disabled");
    if (hasEquivalentSizeSwap) {
      // Show equivalent size message
      $(".preOrderOnPdp").html(equivalentSizeMessage).show();
      $(".product-form").find(".product-form__submit").text("Add to cart");

      // Add hidden field for size swap property
      const swapMessage = equivalentSizeMessage.replace(/<\/?div>/g, ' ').trim();
      const hiddenFieldHTML = `<input type="hidden" id="bundle-size-swap-info" value="${swapMessage}" name="properties[Size Swap]">`;
      $(".product-form form").append(hiddenFieldHTML);
    } else if (pre_order) {
      // Build pre-order message showing specific items
      let preOrderMessage = '<div>The following are pre-order items: ';

      // List all pre-order items
      preOrderItems.forEach((item, index) => {
        if (index > 0) {
          preOrderMessage += ', ';
        }
        preOrderMessage += item.fullTitle;
      });

      preOrderMessage += '. </div>';

      // Add target availability (use the first item's date, or most common date)
      let availabilityText = target_avai;
      if (!availabilityText || availabilityText.trim() === '') {
        availabilityText = 'soon';
      }

      preOrderMessage += `<div>Target availability ${availabilityText}.</div>`;

      $(".preOrderOnPdp").html(preOrderMessage).show();
      $(".product-form").find(".product-form__submit").text(window.variantStrings.preOrder);

      // Add hidden field for pre-order property
      const hiddenPreorderMessage = `Target availability ${availabilityText}.`;
      const hiddenFieldHTML = `<input type="hidden" id="bundle-preorder-item-info" value="${hiddenPreorderMessage}" name="properties[Pre-order]">`;
      $(".product-form form").append(hiddenFieldHTML);
    } else {
      $(".product-form").find(".product-form__submit").text("Add to cart");
      $(".preOrderOnPdp").hide();
    }
  }
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function checkCookie() {
  let user = getCookie("username");
  if (user != "") {
    alert("Welcome again " + user);
  } else {
    user = prompt("Please enter your name:", "");
    if (user != "" && user != null) {
      setCookie("username", user, 365);
    }
  }
}

function waitForElm1(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        observer.disconnect();
        resolve(document.querySelector(selector));
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}
